export const ruRu = (__LOCALE_RU__ ? ({
  permission_tag_list_table_viewer: {
    tags_count: 'Найдено: {{count}}',
    permission_tag_list_table: {
      permission_tag: 'Название',
      created_by_user: 'Создано',
      create_time: 'Дата создания',
      groups: 'Группы',
    },
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  permission_tag_list_table_viewer: {
    tags_count: 'Found: {{count}}',
    permission_tag_list_table: {
      permission_tag: 'Name',
      created_by_user: 'Created',
      create_time: 'Creation date',
      groups: 'Groups',
    },
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  permission_tag_list_table_viewer: {
    tags_count: 'Encontrado: {{count}}',
    permission_tag_list_table: {
      permission_tag: 'Nome',
      created_by_user: 'Criado',
      create_time: 'Data de criação',
      groups: 'Grupos',
    },
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  permission_tag_list_table_viewer: {
    tags_count: 'Encontrado: {{count}}',
    permission_tag_list_table: {
      permission_tag: 'Nombre',
      created_by_user: 'Creado',
      create_time: 'Fecha de creación',
      groups: 'Grupos',
    },
  },
}) : {}) as Record<string, unknown>;
